<h1 mat-dialog-title>Confirm Action</h1>
<div mat-dialog-content>
  <p>{{ data.message }}</p>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-button color="primary" (click)="onConfirm()">Confirm</button>
</div>
